import { ChevronLeft, ChevronRight } from "lucide-react";

export default function TablePagination({
  currentPage = 1,
  pageSize = 0,
  totalItems = 0,
  totalPages,
  onPageChange,
  onPageSizeChange = () => { },
  pageSizeOptions = [20, 50, 100, 500, 1000],
}) {
  const derivedTotalPages = totalPages ?? Math.ceil(totalItems / pageSize) ?? 1;

  const start = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  const isPrevDisabled = currentPage <= 1;
  const isNextDisabled = currentPage >= derivedTotalPages;

  return (
    <div className="flex items-center justify-between p-5 border-t border-gray-200/60 flex-shrink-0 bg-gradient-to-r from-white to-[#f9fbfd]/30">
      {/* left info */}
      <div className="text-sm text-[#739fe1] flex items-center gap-2">
        <span>
          {start}–{end} of {totalItems}
        </span>

        {onPageSizeChange && (
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="ml-2 p-2 border border-gray-200 rounded-lg"
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* right controls */}
      <div className="flex items-center gap-2">
        <button
          className={`p-2 hover:bg-white rounded-lg transition-all hover:shadow-sm ${isPrevDisabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          onClick={() => onPageChange(Math.max(0, Number(currentPage) - 1))}
          disabled={isPrevDisabled}
        >
          <ChevronLeft className="w-4 h-4 text-[#739fe1]" />
        </button>

        <button
          className={`p-2 hover:bg-white rounded-lg transition-all hover:shadow-sm ${isNextDisabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          onClick={() => onPageChange(Number(currentPage) + 1)}
          disabled={isNextDisabled}
        >
          <ChevronRight className="w-4 h-4 text-[#739fe1]" />
        </button>
      </div>
    </div>
  );
}
